import {BASE_URL} from './SystemConstants';

export const APARTMENTTENANTS_URL = BASE_URL + 'apartmenttenants';
export const APARTMENTTENANT_GET = 'APARTMENTTENANT_GET';
export const APARTMENTTENANT_DELETE = 'APARTMENTTENANT_DELETE';
